import styled from 'styled-components';
import { motion, isValidMotionProp } from 'motion/react';
import bg from '../../../assets/images/login/background_default.jpg';
import { rgba } from 'polished'
import { theme } from '../../../theme/theme';
import { desaturate, lighten } from 'polished';
const { 
  first, firstHover,
  second, secondHover,
  third, thirdHover,
  fourth, fourthHover,
  fifth, fifthHover,
} = theme;

// ? Solving 'Warning: React does not recognize the `customProp` prop on a DOM element'
export const blockCustomProps = (prop, defaultValidatorFn) => {
  // List custom props
  const blockedProps = ['customPosition', 'customHeight', 'slidesNumber', 'customTrasnlateX'];
  
  if (blockedProps.includes(prop)) return false;

  if (isValidMotionProp(prop)) return true;

  
  return defaultValidatorFn(prop);
};

export const MainContainer = styled.div`
  position: relative;
  margin: 0;
  padding: 20px 0 60px;
  min-height: 100vh;
  background-image: ${({productBg}) => productBg ? `url(${productBg})` : `url(${bg})` };
  background-size: cover;
  background-attachment: fixed;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: ${({customFlexDirection}) => customFlexDirection ? customFlexDirection : ''};
  justify-content: ${({customFlexDirection, isMobile}) => (customFlexDirection === 'column' && isMobile) ? 'start' : 'center'};
  align-items: ${({customFlexDirection}) => (customFlexDirection==='column') ? 'center' : ''};

  @media (min-width:767px) {
    align-items: center;
  }
`

export const Content = styled.div`
  width: ${({customWidth}) => customWidth ? `${customWidth}` : '90%' };
  max-width: ${({shouldHideProductSelection}) => !shouldHideProductSelection ? `600px` : '1100px' };
  transition: all 1s ease;
  // padding: 48px 40px;
  padding: ${({isMobile}) => (isMobile) ? '28px 40px' : '48px 40px'};
  box-sizing: border-box;
  text-align: center;
  color: white;
  /* Glassmorphism effect */
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  margin-top: 0;
  box-shadow: 0 0 30px 0px rgba(0, 0, 0, 0.3);
  margin-bottom: 10px;

  height: ${({small}) => small ? '600px' : 'min-content' };
  @media (max-width: 767px) {
    width: 95%;
    padding: 20px 20px;
  }

`;

export const InnerContent = styled.div`
  width: ${({customWidth}) => customWidth ? `${customWidth}` : '70%' };
  max-width: 1100px;
  padding: ${({isMobile}) => (isMobile) ? '28px 40px' : '30px 6px'};
  box-sizing: border-box;
  text-align: center;
  color: white;

  /* Glassmorphism effect */
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 16px;
  border: 1px solid ${fifth};
  box-shadow: 0 2px 2px 1px ${fifth};
  margin-bottom: 10px;
  margin: 20px auto 10px;

  
  height: min-content !important;
  @media (max-width: 767px) {
    width: 90%;
  }

  & > div {
    max-width: 50%;
    margin: 0 auto;
  }

`

export const SlideViewport = styled.div`
  overflow: hidden;
  width: 100%;
`;

export const SlideTrack = styled(motion.div).withConfig({
  shouldForwardProp: blockCustomProps
})`
  display: flex;
  width: ${({slidesNumber}) => slidesNumber ? `${String(slidesNumber*100)}%` : '200%'} ;
  transform: translate(${({ $translateX }) => $translateX || '0%'});
  // transition: transform 0.25s ease-in-out;  `;

export const SlidePanel = styled.div`
  padding-inline: 4px;
  width: 50%;
  box-sizing: border-box;
`;

export const Header = styled.h1`
  font-size: 48px;
  margin: 0 0 8px 0;
  color: #fff;

  @media (max-width: 767px) {
    font-size: 28px;
  }
`;

export const SubHeader = styled.h4`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  margin: 0 0 36px 0;
  color: rgba(255,255,255,0.9);

  @media (max-width: 767px) {
    font-size: 16px;
  }
`;

export const CardsWrapper = styled.div`
  display: flex;
  gap: 30px;
  justify-content: center;
  flex-wrap: wrap;
`;

export const Card = styled.div`
  width: 300px;
  min-height: 270px;
  max-height: 270px;
  // color: rgb(104, 91, 91);
  // background: white;
  background: ${props => rgba(props.fifth, 1)};
  color: white;
  backdrop-filter: blur(10px);
  border: ${props => props.isSelected ? '2px solid #836bfd !important' : `2px solid ${props.fifth}`};
  
  border-radius: 12px;
  padding: 28px 20px;
  box-shadow: 0 8px 20px rgba(103, 84, 194, 0.18);
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform .48s ease, box-shadow .48s ease, border .5s ease ;
  user-select: none;
  transform: ${props => props.isSelected ? 'translateY(-4px)' : 'translateY(0px)'};
  border: 1px solid transparent;
  &:hover{
    // transform: translateY(-4px);
    box-shadow: 0 38px 60px -40px white;
    border: 1px solid white;
  }

  @media (max-width: 767px) {
    width: calc(100% - 40px);
    min-height: fit-content;
  }
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 12px;
`

export const ApplicationOptions = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  color: black;

  /* Spacing */
  padding: 0.5rem;
  min-width: 75%;

  display: flex;
  align-items: center;
  justify-content: center;

  /* Typography */
  font-size: 1.025rem;
  white-space: nowrap;

  /* Border and color */
  border: 2px solid #ffffff;
  background-color: #ffffff;
  border-radius: 2px;  

  /* Bg config (Image) */
  background-image: url('/button-dark-2.svg');
  background-repeat: no-repeat;
  background-size: 200%;
  background-position: -480px center;

  @media (max-width: 767px) {
    background-position: -500px center;
  }
  
  /* Transition*/
  transition: 
    background-position 666ms ease,
    color 666ms ease,
    border 666ms ease,
    box-shadow 666ms ease,
    transform 150ms cubic-bezier(0.25, 0.46, 0.45, 0.94);

  &:hover {
    background-position: -80px center;
    border: 2px solid #836bfd;
    color: #ffffff;
  }

  &:hover > * {
    color: #ffffff !important;
  }

  &:active {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.24);
  }
`


export const CardContent = styled.div`
  width: 100%;
  height: 100%;
`;

export const CardImage = styled.img`
  height: 100px;
  max-width: 90%;
  object-fit: contain;
  margin-bottom: 12px;
  min-height: 100px;
  /* background: white;
  padding: 8px;
  border-radius: 8px;  */
`;

export const CardTitle = styled.h3`
  font-family: 'Roboto', sans-serif;
  margin: 6px 0 8px 0;
  font-size: 18px;
  text-align: center;
`;

export const CardDesc = styled.p`
  font-size: 12px;
  color: white;
  // color: rgb(104, 91, 91);
  text-align: center;
  margin: 0;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const DescContainer = styled.div`
  height: 60px;
  text-overflow: ellipsis;
  font-family: 'Roboto', sans-serif;
`

export const StartingHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 24px;
`

export const IconWrapper = styled.div`
  background-color: transparent;
  padding: 4px 6px;
  border-radius: 4px;
  transition: all 333ms ease;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: ${fifth};
  }
  
`


// ? Styled component for the RegisterSuccessful component
export const MailIcon = styled.img`
  width: 110px;
  height: 110px;
  margin-bottom: 20px;
`

export const Title = styled.h2`
  margin: 0;
  font-size: 32px;
  color: white;
  letter-spacing: -0.02em;
`

export const Subtitle = styled.p`
  margin: 18px auto 8px;
  max-width: 420px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 16px;
  line-height: 1.7;
`

export const EmailText = styled.p`
  margin: 0 auto 16px;
  max-width: 420px;
  color: #4dc9ff;
  font-size: 18px;
  font-weight: 700;
  word-break: break-word;
`

export const Instruction = styled.p`
  margin: 0 auto 24px;
  max-width: 440px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 14px;
  line-height: 1.8;
`

export const ActionButton = styled.button`
  width: min(340px, 100%);
  margin: 0 auto 24px;
  padding: 14px 20px;
  border: none;
  border-radius: 16px;
  background: ${first};
  color: white;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 160ms ease, background-color 160ms ease;

  &:hover {
    background: ${firstHover};
    transform: translateY(-1px);
  }

  &:disabled {
    background: ${lighten(0.1, desaturate(0.4, first))};    
    cursor: not-allowed;
    
    &:hover {
      background: ${lighten(0.1, desaturate(0.4, first))};      
      transform: none;
    }
  }
`

export const Footer = styled.div`
  color: rgba(255, 255, 255, 0.74);
  font-size: 13px;
  line-height: 1.7;
`

export const FooterTitle = styled.p`
  margin: 0 0 6px;
  color: white;
  font-weight: 600;
`

export const FooterDescription = styled.p`
  margin: 0;
`

// ? Utility button to siwtch design
export const SwitchDesignBtn = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  padding: 6px 12px;
  border-radius: 6px;
  border: none;
  color: #fff;
  cursor: pointer;
  background-color: #7d2ae8;
  transition: all 0.2s ease;
  width: fit-content;
  z-index: 999;
`



